import { z } from 'zod';

export const backfillTranslationsResponseSchema = z.object({
  filled: z.number(),
  failed: z.number(),
  total: z.number(),
  lastId: z.number().optional(),
});

export type IBackfillTranslationsResponse = z.infer<typeof backfillTranslationsResponseSchema>;
